import { getAuth, onAuthStateChanged } from 'firebase/auth';

export const getStoreUserId = async () => {
  const auth = getAuth();

  return new Promise((resolve, reject) => {
    onAuthStateChanged(
      auth,
      (user) => {
        if (user) {
          return resolve(user.uid);
        }
        return resolve(null);
      },
      reject,
    );
  });
};
